import DOMPurify from 'dompurify';
import type React from 'react';

interface SafeHtmlProps {
  html: string;
}

const SafeHtml: React.FC<SafeHtmlProps> = ({ html }) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtml;
